/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_HighlightsInputs */

const en_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights (one per line)`)
};

const de_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Highlights (eines pro Zeile)`)
};

const fr_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points forts (un par ligne)`)
};

const es_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros (uno por linea)`)
};

const it_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti salienti (uno per riga)`)
};

const nl_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoogtepunten (een per regel)`)
};

const pl_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiagniecia (jedno na linie)`)
};

const fi_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohokohdat (yksi per rivi)`)
};

const da_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hojdepunkter (et per linje)`)
};

const sv_resume_editor_highlights = /** @type {(inputs: Resume_Editor_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hohepunkter (en per rad)`)
};

/**
* | output |
* | --- |
* | "Highlights (one per line)" |
*
* @param {Resume_Editor_HighlightsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_highlights = /** @type {((inputs?: Resume_Editor_HighlightsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_HighlightsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_highlights(inputs)
	if (locale === "fr") return fr_resume_editor_highlights(inputs)
	if (locale === "es") return es_resume_editor_highlights(inputs)
	if (locale === "it") return it_resume_editor_highlights(inputs)
	if (locale === "nl") return nl_resume_editor_highlights(inputs)
	if (locale === "pl") return pl_resume_editor_highlights(inputs)
	if (locale === "fi") return fi_resume_editor_highlights(inputs)
	if (locale === "da") return da_resume_editor_highlights(inputs)
	if (locale === "sv") return sv_resume_editor_highlights(inputs)
	return en_resume_editor_highlights(inputs)
});